module.exports = __webpack_public_path__ + "static/img/GU.72e502dc.png";